export default "__VITE_ASSET__3d28dd77__"